var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrewTickCol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47852 17.4885L1.41797 19.8088H0.494141V3.11542L2.75 0.709167H19.0566L21.1836 2.62128L21.5488 12.7189C21.3698 13.8934 20.7367 16.4443 19.6367 17.2521C18.5367 18.0599 9.73958 17.7463 5.47852 17.4885Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.957 2.57812C9.89085 2.57812 9.02344 3.44554 9.02344 4.51172V8.37891C9.02344 9.44509 9.89085 10.3125 10.957 10.3125C12.0232 10.3125 12.8906 9.44509 12.8906 8.37891V4.51172C12.8906 3.44554 12.0232 2.57812 10.957 2.57812Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.957 15.4688C12.0249 15.4688 12.8906 14.6031 12.8906 13.5352C12.8906 12.4673 12.0249 11.6016 10.957 11.6016C9.88914 11.6016 9.02344 12.4673 9.02344 13.5352C9.02344 14.6031 9.88914 15.4688 10.957 15.4688Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2076 0H3.70644C1.66268 0 0 1.66268 0 3.70644V19.9805C0 20.4744 0.53307 20.7815 0.959449 20.5428L5.41651 18.0469H18.2077C20.2514 18.0469 21.9141 16.3842 21.9141 14.3404V3.70644C21.9141 1.66268 20.2514 0 18.2076 0ZM20.625 14.3404C20.625 15.6734 19.5406 16.7578 18.2076 16.7578H5.24833C5.13807 16.7578 5.02962 16.7861 4.93341 16.84L1.28906 18.8808V3.70644C1.28906 2.37351 2.37347 1.28906 3.70644 1.28906H18.2076C19.5406 1.28906 20.625 2.37346 20.625 3.70644V14.3404Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrewTickCol);
export default __webpack_public_path__ + "static/media/CrewTickCol.f9a197cc4ed4f64b5d0dfc41b6e3aa70.svg";
export { ForwardRef as ReactComponent };